import { ShortFooter } from '@carnica/smart-kit';

export default ShortFooter;
